<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">OID 목록</div>
        <div class="setting-addel mr-r15">
          <el-button size="mini" @click="addTrapEvent" :disabled="!selectedRow"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="deleteTrapEvent" :disabled="checkedRow.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
        <span class="mr-r5">적용여부</span>
        <div class="setting-addel">
          <!-- add 1210 height ie friendly -->
          <el-button size="mini" style="height:27px" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" style="height:27px" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" type="primary" :disabled="!checkDifferenceEventListDataFlag" @click="onSaveButton">저장</el-button>
        <el-button class="mr-r4" size="mini" :disabled="!checkDifferenceEventListDataFlag" @click="onCancelButton">취소</el-button>
        <w-header-search-button @click="toggleSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :column-default="columnDefault" :data="trapEventDatas" :columns="columns" highlight-current-row :show-custom-header="true" :show-search-tool="showSearchTool"
      row-class-name="c-dblclick display-exceptional" @row-click="selectEvent" @row-dblclick="onRowDblClick" @selection-change="onSelectionChange">
        <template slot-scope="scope" slot="apply-flag-slot">
          <el-switch v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="changeDifferenceDataFlag"/>
        </template>
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId" />
        </template>
        <template slot-scope="scope" slot="judge-flag">
          <el-checkbox true-label="Y" false-label="N" v-model="scope.row.judgeFlag" @change="changeDifferenceDataFlag"/>
        </template>
        <template slot-scope="scope" slot="judge-condition">
          {{getJudgeCondition(scope.row)}}
        </template>
      </el-table-wrapper>
    </el-row>
    <w-trap-event-setting-popup title="정책 수정" ref="updateEventPopup" :oid-data="selectedRow"
    :selected-event-data="selectedEvent" :max-event-index="maxEventIndex" :event-datas="trapEventDatas"
    @init-form-data="initSelectEvent"
    @update-event-inform="loadData" />
    <w-trap-event-setting-popup title="정책 추가" ref="addEventPopup" :oid-data="selectedRow" :max-event-index="maxEventIndex" :event-datas="trapEventDatas"
    @init-form-data="initSelectEvent"
    @update-event-inform="loadData" />
  </div>
</template>

<script>
import { isEmpty, isEqual, differenceWith, cloneDeep, sortBy, every } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';
import snmptrapSettingAPI from '@/api/settings/log/snmptrap-settings';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WTrapEventSettingPopup from '../popup/TrapEventSettingPopup';

export default {
  name: 'WTrapEventTable',
  props: {
    selectedRow: {
      type: Object,
    },
  },
  components: {
    WTrapEventSettingPopup,
    WEventlevelCell,
  },
  data() {
    const columns = [
      {
        type: 'selection',
        width: '40',
      },
      {
        prop: 'applyFlag',
        label: '적용',
        width: '60px',
        scopedSlot: 'apply-flag-slot',
        sortable: true,
      },
      {
        prop: 'eventIndex',
        label: '판단 순위',
        width: '80px',
        searchable: true,
        sortable: true,
      },
      {
        prop: 'eventlevelName',
        label: '정책 등급',
        width: '85px',
        scopedSlot: 'eventlevel-slot',
        searchable: true,
        sortable: true,
      },
      {
        prop: 'snmpOid',
        label: 'Sub OID',
        width: '200px',
        searchable: true,
        sortable: true,
      },
      {
        prop: 'judgeFlag',
        label: '판단조건 사용 여부',
        align: 'center',
        width: '120px',
        scopedSlot: 'judge-flag',
      },
      {
        prop: 'judgeCondition',
        label: '판단 조건',
        align: 'center',
        scopedSlot: 'judge-condition',
        sortable: true,
      },
      {
        prop: 'judgeValue',
        label: '값',
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      showSearchTool: false,
      oidDatas: {},
      columns,
      selectedEvent: null,
      trapEventDatas: [],
      trapEventOriginDatas: [],
      checkedRow: [],
      checkDifferenceEventListDataFlag: false,
      maxEventIndex: 0,
      columnDefault,
      collectAll: false,
    };
  },
  watch: {
    selectedRow: {
      immediate: true,
      handler() {
        if (!isEmpty(this.selectedRow)) {
          this.oidDatas = this.selectedRow;
          this.loadData();
        } else {
          this.trapEventDatas = [];
          this.trapEventOriginDatas = [];
        }
      },
    },
  },
  methods: {
    loadData() {
      const snmptrapOid = this.oidDatas.snmptrapOid;
      const snmptrapVersion = this.oidDatas.snmptrapVersion;
      const params = {
        params: {
          snmptrapOid,
          snmptrapVersion,
        },
      };
      snmptrapSettingAPI.getSnmptrapEventRuleList(params).then((response) => {
        this.trapEventDatas = cloneDeep(response.data.data);
        this.trapEventOriginDatas = cloneDeep(response.data.data);
        this.$nextTick(() => {
          this.changeDifferenceDataFlag();
        });
        let maxIndex = 0;
        if (!isEmpty(this.trapEventDatas)) {
          const sortedDatas = sortBy(this.trapEventDatas, ['eventIndex']);
          maxIndex = sortedDatas[sortedDatas.length - 1].eventIndex;
        }

        this.maxEventIndex = maxIndex;
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'OID 목록', false));
        throw new Error(e);
      });
    },
    getJudgeCondition(row) {
      let label = '';
      if (row.judgeFlag) {
        const condition = row.judgeCondition;
        switch (condition) {
          case ('EQ'): label = '=='; break;
          case ('NEQ'): label = '!='; break;
          case ('GT'): label = '>'; break;
          case ('GE'): label = '>='; break;
          case ('LT'): label = '<'; break;
          case ('LE'): label = '<='; break;
          case ('CT'): label = '포함'; break;
          case ('NCT'): label = '미포함'; break;
          default: label = EMPTY_TEXT; break;
        }
      }
      return label;
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    selectEvent(row) {
      this.selectedEvent = row;
    },
    addTrapEvent() {
      this.$refs.addEventPopup.open();
    },
    deleteTrapEvent() {
      this.$confirm(...msgUtils.getBasicConfirmData('정책을 삭제')).then(() => {
        snmptrapSettingAPI.deleteSnmptrapEventRule(this.checkedRow).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', response.data.success));
            this.loadData();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    onRowDblClick() {
      this.$refs.updateEventPopup.open();
    },
    onSelectionChange(selection) {
      this.checkedRow = selection;
    },
    changeDifferenceDataFlag() {
      this.changeCollectAll();
      this.checkDifferenceEventListDataFlag = !isEqual(this.trapEventDatas, this.trapEventOriginDatas);
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        this.trapEventDatas.forEach((item) => {
          item.applyFlag = 'Y';
        });
      } else {
        // false : 전체 선택 해제
        this.trapEventDatas.forEach((item) => {
          item.applyFlag = 'N';
        });
      }
      this.changeDifferenceDataFlag();
    },
    changeCollectAll() {
      if (isEmpty(this.trapEventDatas)) {
        this.collectAll = false;
        return;
      }
      if (every(this.trapEventDatas, { applyFlag: 'Y' })) {
        this.collectAll = true;
      } else {
        this.collectAll = false;
      }
    },
    onSaveButton() {
      const params = differenceWith(this.trapEventDatas, this.trapEventOriginDatas, isEqual);
      snmptrapSettingAPI.updateSnmptrapEventRule(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.loadData();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    onCancelButton() {
      this.trapEventDatas = cloneDeep(this.trapEventOriginDatas);
      this.changeDifferenceDataFlag();
    },
    /**
     * 팝업창 close 시에 선택된 정책 항목을 제거한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    initSelectEvent() {
      this.selectedEvent = null;
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/components/TrapEventTable.vue